import React from "react";
import { LeadForm } from "../components/LeadForm";
import { Users, CalendarDays, ChefHat } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1728910156510-77488f19b152?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Catering() {
  return (
    <div data-testid="catering-page">
      <section className="relative bg-navy hero-motif">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="overline text-gold mb-3">Celebrations, elevated</div>
            <h1 className="font-serif text-4xl sm:text-5xl text-cream leading-tight">Catering & Bulk Orders</h1>
            <p className="text-cream/75 mt-4 max-w-lg">From intimate gatherings to grand weddings — let Begum's bring royal flavours to your event. Request a custom quote and our team will craft the perfect menu.</p>
            <div className="flex gap-6 mt-8 text-cream/80">
              {[[Users, "Any Group Size"], [CalendarDays, "Flexible Dates"], [ChefHat, "Custom Menus"]].map(([Icon, t], i) => (
                <div key={i} className="flex items-center gap-2 text-sm"><Icon size={16} className="text-gold" /> {t}</div>
              ))}
            </div>
          </div>
          <div className="relative"><div className="absolute -inset-3 border border-gold/30 rounded-2xl" /><img src={IMG} alt="Catering spread" className="relative rounded-2xl w-full aspect-[4/3] object-cover" /></div>
        </div>
      </section>
      <section className="max-w-2xl mx-auto px-4 sm:px-6 py-14">
        <div className="bg-white rounded-2xl border border-black/5 p-7">
          <LeadForm source="Catering" title="Request a Quote" cta="Request a Quote"
            fields={["name", "phone", "email", "event_type", "event_date", "guests", "location", "budget", "message"]} />
        </div>
      </section>
    </div>
  );
}
